import {useEffect,useState} from 'react';
import {collection,onSnapshot} from 'firebase/firestore';
import {db} from '../../Security/firebase-config';

export default function useOverviewAvailability(events,uid) {
  const teamIds=JSON.stringify([...new Set(events.filter(event=>event.calendar==='team').map(event=>event.__teamId).filter(Boolean))].sort());
  const identity=JSON.stringify([uid,teamIds]);
  const [state,setState]=useState(null);
  useEffect(()=>{
    if(!uid)return undefined;
    let alive=true;
    const update=(id,value)=>{if(alive)setState(current=>({identity,teams:{...(current?.identity===identity?current.teams:{}),[id]:value}}));};
    const stops=JSON.parse(teamIds).map(id=>onSnapshot(collection(db,'teams',id,'availabilities'),snapshot=>update(id,{ready:true,records:snapshot.docs.map(item=>({...item.data(),id:item.id}))}),()=>update(id,{ready:false,error:true})));
    return()=>{alive=false;stops.forEach(stop=>stop());};
  },[uid,teamIds,identity]);
  return state?.identity===identity?state.teams:{};
}
